const FoodMenu = () =>
    import(/* webpackChunkName: "foodmenu-module" */ '@views/menu/FoodMenu.vue');
const Day = () =>
    import(/* webpackChunkName: "foodmenu-module" */ '@views/menu/views/Day.vue');
const Week = () =>
    import(/* webpackChunkName: "foodmenu-module" */ '@views/menu/views/Week.vue');
const EmployeeMeals = () =>
    import(/* webpackChunkName: "foodmenu-module" */'@/views/menu/views/employee_meals/EmployeeMeals.vue');
const Settings = () =>
    import(/* webpackChunkName: "foodmenu-module" */'@views/menu/views/employee_meals/EmployeeMealSettings.vue');
import store from '@/store';
import {requireModule} from '@/routes/guards';

export default [
    {
        path: '/menu',
        components: { base: FoodMenu },
        beforeEnter: requireModule('food_menu', (to, from, next) => {
            if (store.getters.canAccessFoodmenuIndex) {
                next();
            } else {
                next({ path: '/access-restricted' });
            }
        }),
        children: [
            {
                path: 'day',
                name: 'foodmenu.day',
                components: { foodmenu: Day }
            },
            {
                path: 'week',
                name: 'foodmenu.weekly',
                components: { foodmenu: Week }
            },
            {
                path: '/statistics/menu',
                name: 'foodmenu.statistics'
            }
        ]
    },
    {
        path: '/menu/employees',
        name: 'foodmenu.employee.meals',
        components: {base: EmployeeMeals},
        beforeEnter: requireModule('employee_meals')
    },
    {
        path: '/menu/settings',
        name: 'foodmenu.settings',
        components: {base: Settings},
        beforeEnter: requireModule('employee_meals')
    }
];
